import { useContext } from "react";
import { useSelector } from "react-redux";
import { ProjectReport, Identifiable } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeProjectReport(
    report: Boundaries["removeProjectReport"]["request"],
  ): void;
}

function useRemoveProjectReport(
  report: Identifiable<ProjectReport>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveProjectReportRequestPending(report),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveProjectReportRequestSuccess(report),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveProjectReportRequestFailure(report),
    ),
    removeProjectReport: core.removeProjectReport,
  };
}

export { useRemoveProjectReport };
